<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.offers')">Special Offers</inertia-link>
      <span class="text-indigo-400 font-medium">/Edit</span>
    </h1>
    <Form mode="edit" :formData="offer" @submit="handleUpdateOffer" @delete="handleDeleteOffer" :businessTypes="business_types" :errors="errors" :dups="dups" />
  </div>
</template>
<script>
import Form from './Form'
import Layout from '@/Shared/Admin/Layout'
export default {
  name: 'Edit',
  layout: Layout,
  components: {
    Form
  },

  props: {
    offer: {
      type: Object,
      required: true
    },
    errors: Object,
    business_types: {
      type: Object,
      required: true,
    },
    dups: [Object,Array],
  },

  methods: {
    handleUpdateOffer(offer) {
      this.$inertia.put(route('manage.offers.update', this.offer.id), offer)
    },
    handleDeleteOffer(offer) {
      if (confirm('Are you sure you want to delete this offer?')) {
        this.$inertia.delete(route('manage.offers.destroy', this.offer.id))
      }
    }
  }
}
</script>
